import _ from "lodash";
import * as Yup from "yup";
import {FormGridField} from "../../../../utils/forms/components/FormGrid";

export const baseConfigInitialFields = _.memoize(
    ({subsidiaries, isDisabled}): FormGridField[] => [
        {
            name: "name",
            fieldType: "input",
            fieldOptions: {
                id: "name",
                placeholder: "Mailing List Name",
                inputType: "text",
                label: "Mailing List Name"
            },
            validation: Yup.string()
                .required("Field is required.")
                .max(20, "Max. 20 characters.")
                .matches(
                    new RegExp(/^[\w\-\ \.]+$/),
                    `Special characters not supported.`
                ),
            columnClass: "col-6",
            formSpacing: false
        },
        {
            name: "subsidiary",
            fieldType: "select",
            fieldOptions: {
                id: "subsidiary_preset",
                noValueLabel: "Choose subsidiary",
                label: "Subsidiary",
                items: subsidiaries,
                disabled: isDisabled
            },
            validation: Yup.string().nullable().required("Field is required."),
            columnClass: "col-6"
        },
    ]
)